import styled from "vue-styled-components";

export const Content = styled.div`
    .modal-dialog {
        max-width: 300px;
        margin: auto;

        .modal-body {
            padding: 0;
            max-height: 100%;
        }
    }
`;
